<template>
  <el-dialog
    :title="title"
    :visible.sync="isEdit"
    v-if="isEdit"
    :close-on-click-modal="false"
    @close="closeFrom"
  >
    <el-form
      ref="fForm"
      :model="fObject"
      size="small"
      :rules="rules"
      label-width="100px"
    >
      <el-row>
        <el-col>
          <el-form-item label="处理意见：" prop="handleNotes">
            <el-input
              rows="3"
              type="textarea"
              v-model="fObject.handleNotes"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="通知方式：" prop="noticeType">
            <el-radio-group v-model="fObject.noticeType">
              <el-radio-button
                v-for="(item, i) in noticeTypeList"
                size="medium"
                :label="item.paramKey"
                :key="i"
              >
                {{ item.paramValue }}
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click.native="closeFrom()" btntype title="取消"></butn>
      <butn btntype="primary" @click.native="updateForm()" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import Bus from "./Bus";
import rulesFactory from "@/utils/rules";
import { getDataMap } from "@/api/sysParam";
import { feedbackUpdate } from "@/api/feedback";

// const emptyObject = Object.create(null);
export default {
  name: "update",
  components: { butn },
  data() {
    return {
      isEdit: false,
      title: "编辑",
      fObject: {
        noticeType: "0",
      },
      noticeTypeList: [],
      rules: {
        handleNotes: [rulesFactory.required("请输入处理意见")],
        noticeType: [rulesFactory.required("请选择通知方式")],
      },
    };
  },
  methods: {
    // 获取数据字典
    getSysParam(param) {
      getDataMap(param).then((res) => {
        if (res && res.code == 0) {
          this.noticeTypeList = res.data.slice(0, 1);
        }
      });
    },
    closeFrom() {
      this.isEdit = false;
      // 点击取消 数据重置
      this.$refs['fForm'].resetFields();
    },
    updateForm() {
      this.$refs["fForm"].validate((valid) => {
        if (valid) {
          feedbackUpdate(Object.assign({}, this.fObject)).then(() => {
            this.fObject.handleNotes = "";
            Bus.$emit("initData");
          });
          this.closeFrom();
        }
      });
    },
  },
  created() {
    this.getSysParam("NOTICE_TYPE");

    Bus.$on("feedbackUpdate", (uuid) => {
      this.isEdit = true;
      this.fObject.uuid = uuid;
    });
  },
};
</script>
